export default {
  // Text Panel
  '文本': 'Text',
  '颜色': 'Farbe',
  '字体': 'Schriftart',
  '大写': 'Großbuchstaben',
  '字号': 'Schriftgröße',
  '背景色': 'Hintergrundfarbe',
  '圆角': 'Randradius',
  '内边距': 'Polsterung',
  '描边': 'Umrandung',
  '对齐': 'Ausrichtung',
  '底边距': 'Untermargin',
  '紧贴底边': 'Unten ausrichten',
  '垂直居中': 'Vertikal zentrieren',

  // Basic Panel
  '基础': 'Grundlegend',
  '位置': 'Position',
  '尺寸': 'Größe',
  '旋转': 'Drehung',
  '居中': 'Zentrieren',
  '原始尺寸': 'Ursprüngliche Größe',
  '平铺': 'Kacheln',
  '拉伸': 'Strecken',
  '透明度': 'Transparenz',
  '视频尺寸为{width}x{height}。': 'Videogröße ist {width}x{height}.',
  '调整文本尺寸可能会改变文本展示效果，建议调整字体大小': 'Die Anpassung der Textgröße kann die Textanzeige ändern, es wird empfohlen, die Schriftgröße anzupassen',

  // Library
  '视频': 'Video',
  '音频': 'Audio',
  '图片': 'Bild',
  '新建文本': 'Neuer Text',
  '花字库': 'Schriftbibliothek',
  '默认文本': 'Standardtext',

  // Export
  '导出': 'Exportieren',

  // Tools
  '撤销': 'Rückgängig',
  '重做': 'Wiederholen',

  // Tooltips
  '清除选中': 'Auswahl löschen',
  '删除当前选中': 'Auswahl löschen',
  '分割当前选中': 'Auswahl teilen',
  '分割当前选中，只保留左侧': 'Auswahl teilen, nur links behalten',
  '分割当前选中，只保留右侧': 'Auswahl teilen, nur rechts behalten',
  '水平翻转': 'Horizontal spiegeln',
  '将连续且相邻的素材拼接后下载': 'Kontinuierliche und aufeinanderfolgende Materialien verbinden und herunterladen',

  // Library
  '当前': 'Aktuell',
  '导入': 'Importieren',
  '全部': 'Alle',
  '删除': 'Löschen',
  '拖拽视频到这里': 'Video hierher ziehen',
  '拖拽音频到这里': 'Audio hierher ziehen',
  '拖拽图片到这里': 'Bild hierher ziehen',
  '或者点击上传': 'oder klicken Sie zum Hochladen',
  '暂无素材，请先导入素材': 'Keine Materialien vorhanden, bitte importieren Sie zuerst Materialien',

  // Manager
  '选择一个视频，开始你的创作。': 'Wählen Sie ein Video und beginnen Sie Ihre Erstellung.',

  // Animation Panel
  '动画': 'Animation',
  '入场动画': 'Einstiegsanimation',
  '出场动画': 'Austiegsanimation',
  '关键帧动画': 'Keyframe-Animation',
  '选择动画效果': 'Wählen Sie einen AnimationsEffekt',
  '添加': 'Hinzufügen',
  '确定删除此动画？': 'Sind Sie sicher, dass Sie diese Animation löschen möchten?',
  '持续时间': 'Dauer',
  '秒': 'Sek',
  '起始时间': 'Startzeit',
  '结束时间': 'Endzeit',
  '暂无动画，请添加动画效果': 'Keine Animationen, bitte fügen Sie AnimationsEffekte hinzu',

  // Animation Presets
  '淡入': 'Einfaden',
  '从左滑入': 'Von links hereinrutschen',
  '从右滑入': 'Von rechts hereinrutschen',
  '从上滑入': 'Von oben hereinrutschen',
  '从下滑入': 'Von unten hereinrutschen',
  '放大进入': 'Heranzoomen',
  '旋转进入': 'Drehung herein',
  '淡出': 'Ausfaden',
  '向左滑出': 'Nach links herausrutschen',
  '向右滑出': 'Nach rechts herausrutschen',
  '向上滑出': 'Nach oben herausrutschen',
  '向下滑出': 'Nach unten herausrutschen',
  '缩小退出': 'Wegzoomen',
  '旋转退出': 'Drehung heraus',
  '脉冲': 'Impuls',
  '抖动': 'Schütteln',
  '弹跳': 'Prallen',
  '摆动': 'Schwingen',
  '闪烁': 'Blinken',
  '自定义': 'Benutzerdefiniert',
  '起始状态': 'Startzustand',
  '结束状态': 'Endzustand',
  '位置 X': 'Position X',
  '位置 Y': 'Position Y',
  '缩放': 'Skalierung',
  '旋转角度': 'Drehung',
  '不透明度': 'Deckkraft',

  // Filter Panel
  '可用滤镜': 'Verfügbare Filter',
  '滤镜参数': 'Filterparameter',
  '选择滤镜': 'Filter auswählen',
  '请选择要编辑的滤镜': 'Bitte wählen Sie einen Filter zum Bearbeiten aus',
  '强度': 'Intensität',
  '请选择一个滤镜以调节参数': 'Bitte wählen Sie einen Filter, um Parameter anzupassen',
  '灰度': 'Graustufen',
  '模糊': 'Unschärfe',
  '亮度': 'Helligkeit',
  '对比度': 'Kontrast',
  '饱和度': 'Sättigung',

  '无': 'Keine',
  '入场': 'Eingang',
  '出场': 'Ausgang',
  '动效': 'Animation',
  '结束位置': 'Endposition',
  '使用当前时间轴上的当前时间点': 'Verwenden Sie den aktuellen Zeitpunkt auf der Zeitleiste',
  '开始位置': 'Startposition',
  '当前有动画，调整可能不能直接看到效果，请播放片段查看': 'Die aktuelle Animation zeigt möglicherweise keine direkten Effekte, bitte spielen Sie das Segment ab, um es zu überprüfen',
  '滤镜': 'Filter',
  '恢复正在编辑的数据': 'Wiederherstellen der bearbeiteten Daten',
  '转场': 'Übergang',
  '转场效果': 'Übergangseffekte',
  '点击应用': 'Klicken Sie an, um anzuwenden',
  '仅支持视频和图片': 'Nur Video und Bilder werden unterstützt',
  '删除转场': 'Übergang löschen',
  '已经存在视频转场，请先删除': 'Es gibt bereits einen Videoübergang, bitte löschen Sie ihn zuerst',
  '当前片段是轨道最后一个片段，不能应用转场效果': 'Das aktuelle Segment ist das letzte Segment der Spur, ein Übergangseffekt kann nicht angewendet werden',
  '暂无转场效果': 'Keine Übergangseffekte verfügbar',
  '片段不存在': 'Segment existiert nicht',
  '请先选择一个片段': 'Bitte wählen Sie zuerst ein Segment aus',
  '轨道不存在': 'Spur existiert nicht',
  '默认': 'Standard',

  // 转场效果
  '淡入淡出': 'Überblenden',
  '滑动': 'Gleiten',
  '百叶窗': 'Jalousien',
  '溶解': 'Auflösung',

  // Video/Audio Panel
  '音量': 'Lautstärke',
  '请先选择视频片段': 'Bitte wählen Sie zuerst ein Videosegment',
  '请先选择音频片段': 'Bitte wählen Sie zuerst ein Audiosegment',
  '重置': 'Zurücksetzen',

  // Advanced Export
  '高级导出': 'Erweiterter Export',
  '取消': 'Abbrechen',
  '正在导出...': 'Exportiert...',
  '导出完成！': 'Export abgeschlossen!',
  '导出失败：': 'Export fehlgeschlagen: ',
  '导出类型': 'Exporttyp',
  '输出格式': 'Ausgabeformat',
  '分辨率': 'Auflösung',
  '帧率': 'FPS',
  '视频比特率': 'Videobitrate',
  '编码格式': 'Codec',
  '包含音频': 'Audio einschließen',
  '关闭时将导出无声音的视频': 'Exportiert Video ohne Ton, wenn deaktiviert',
  '音频比特率': 'Audio-Bitrate',
  '比特率': 'Bitrate',
  '采样率': 'Abtastrate',
  '导出中...': 'Export läuft...',
  '开始导出': 'Export starten',
};